import {imagesSushi} from "./imagesSushi";

export const sushi = [
    {
        id: 41,
        img: imagesSushi.spaisiTunec,
        title: 'СПАЙСИ ТУНЕЦ',
        structure: 'РИС, НОРИ,ТУНЕЦ, СОУС СПАЙСИ',
        price: '85',
        count: '1',
        weight: '35',
    },
    {
        id:42 ,
        img: imagesSushi.spaisiMidii,
        title: 'СПАЙСИ МИДИИ',
        structure: 'РИС, НОРИ, МИДИИ, СОУС СПАЙСИ.',
        price: '70',
        count: '1',
        weight: '35',
    },
    {
        id:43 ,
        img: imagesSushi.tunec,
        title: 'ТУНЕЦ',
        structure: 'РИС, ТУНЕЦ.',
        price: '80',
        count: '1',
        weight: '32',
    },
    {
        id: 44,
        img: imagesSushi.spaisiGrebeshok,
        title: 'СПАЙСИ ГРЕБЕШОК',
        structure: 'РИС, ГРЕБЕШОК, СПАЙСИ СОУС.',
        price: '85',
        count: '1',
        weight: '35',
    },
    {
        id:45 ,
        img: imagesSushi.spaisiIzumiTai,
        title: 'СПАЙСИ ИЗУМИ ТАЙ',
        structure: 'РИС, НОРИ,ИЗУМИ ТАЙ, СПАЙСИ СОУС.',
        price: '70',
        count: '1',
        weight: '35',
    },
    {
        id:46 ,
        img: imagesSushi.spaisiUgor,
        title: 'СПАЙСИ УГОРЬ',
        structure: 'РИС, УГОРЬ, СПАЙСИ СОУС.',
        price: '95',
        count: '1',
        weight: '35',
    },
    {
        id: 47,
        img: imagesSushi.spaisiLosos,
        title: 'СПАЙСИ ЛОСОСЬ',
        structure: 'РИС,ЛОСОСЬ, СПАЙСИ СОУС.',
        price: '85',
        count: '1',
        weight: '35',
    },
    {
        id: 48,
        img: imagesSushi.spaiseKrab,
        title: 'СПАЙСИ КРАБ',
        structure: 'РИС, НОРИ,МЯСО КРАБА (ИМИТАЦИЯ), СПАЙСИ СОУС.',
        price: '70',
        count: '1',
        weight: '35',
    },
]